import useErrorHandlerModule from '@/composable/useErrorHandlerModule'
import AuthError from '@/entities/errors/api_errors/AuthError'
import { AxiosInstance } from 'axios'
const errorHandlerModule = useErrorHandlerModule()

let logoutPromise: Promise<void> | null = null

export const axiosUnauthorizedInterceptorHelper = (instance: AxiosInstance): void => {
  instance.interceptors.response.use(
    response => response,
    async error => {
      if (error.response?.status === 401 && !error.config?.url?.includes('/logout')) {
        if (!logoutPromise) {
          logoutPromise = errorHandlerModule.handleAuthErrors(new AuthError(error.response.data?.error)).finally(() => {
            logoutPromise = null
          })
        }
        await logoutPromise
      }
      return Promise.reject(error)
    },
  )
}
